import { UntypedFormGroup } from '@angular/forms';
import { IDynamicFormGroupDefinition } from '../../dynamic-forms/models/dynamic-form-group';

export abstract class GenericLookupForm {
  formInfo: IDynamicFormGroupDefinition;
  form: UntypedFormGroup;

  public reset(): void {
    this.form.reset();
  }

  public getValue(): any {
    if (this.form.valid) {
      return this.form.value;
    }
  }

  public abstract isValid(): boolean;
}
